import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { SnackbarComponent } from "src/app/snackbar/snackbar.component";
import { LmsService } from "../services/lms.service";

declare var $: any;

@Component({
  selector: "app-enach-easebuzz",
  templateUrl: "./enach-easebuzz.component.html",
  styleUrls: ["./enach-easebuzz.component.scss"],
  standalone: false,
})
export class EnachEasebuzzComponent implements OnInit {
  showSpinner: boolean = false;
  LoanAcNo: any;
  Status: any = "Pending";
  status: any;
  ApplicationNo: string = "";
  Type: string = "ALL";
  LoanDateFrom: any;
  LoanDateTo: any;
  currentUser: any;
  FileCheckingList: any;

  dataSourceEnachEasebuzz: any;
  displayedColumnsEnachEasebuzz: string[] = [];
  ChequeId: MatTableDataSource<unknown>;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  applicationDetail: any;
  StatusDate: any = new Date();
  EMIFrom: any = 0;
  EMITo: any = 0;
  Loan_Id: any;
  LastEMI: any;
  identifier: any;
  Id: any;

  constructor(
    private dataSharingService: DataSharingService,
    private snackBar: MatSnackBar,
    private lmsService: LmsService,
  ) {}

  ngOnInit(): void {
    this.LoanDateFrom = new Date();
    this.LoanDateTo = new Date();
    this.dataSharingService.HeaderTitle.next("EASEBUZZ ENACH Generation");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));

    this.displayedColumnsEnachEasebuzz = [
      "Id",
      "LoanAcNo",
      "Application_No",
      "CustomerName",
      "Loan_Date",
      "PresentBankInCompanyName",
      "PresentBankInCompany",
      "Status",
      "Action",
    ];
  }

  onSearchEnachEasebuzz() {
    console.log("search button clicked");
    this.showSpinner = true;

    this.lmsService
      .LMS_Get_Easebuzz_NachStatus({
        fromDate: this.LoanDateFrom,
        toDate: this.LoanDateTo,
        LoanAcNo: this.LoanAcNo,
        status: this.Status,
        Application_No: this.ApplicationNo,
        Type: this.Type,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res: any) => {
        if (res.length > 0) {
          this.FileCheckingList = JSON.parse(JSON.stringify(res));
          this.ChequeId = res[0].chqId;
          this.dataSourceEnachEasebuzz = new MatTableDataSource(
            JSON.parse(JSON.stringify(res)),
          );
          this.dataSourceEnachEasebuzz.sort = this.sort;
          this.dataSourceEnachEasebuzz.paginator = this.paginator;
          this.showSpinner = false;
        } else {
          this.dataSourceEnachEasebuzz = null;
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.showSpinner = false;
        }
      });
  }

  goToDetail(row) {
    this.Loan_Id = row.Loan_Id;
    this.changeDate();
    this.status = row.status;
    this.Id = row.Id;
    this.lmsService
      .Lms_Get_Nach_Au_Detail({
        LoanAcNo: row.LoanAcNo,
        Id: row.chqId,
        SearchStatus: row.Status,
      })
      .subscribe((res: any) => {
        this.FileCheckingList = JSON.parse(JSON.stringify(res));
        console.log("Data for Get Nach Info", this.FileCheckingList);
        if (res.length > 0) {
          this.applicationDetail = res[0];
          $("#addAUEnachInfo").modal("show");
          $("#addAUEnachInfo").css("z-index", "1050");
        }
      });
  }

  OnClose() {
    $("#addAUEnachInfo").modal("hide");
  }

  EMIFromChange() {}

  onSaveEnachEasebuzzInfo() {
    if (this.EMIFrom == 0 || this.EMITo == 0) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "EMI From or EMI To not equal to 0!!",
        ...this.configSuccess,
      });
    } else {
      this.lmsService
        .LMS_Save_Nupay_ENachInfo({
          EMIFrom: this.EMIFrom,
          EMITo: this.EMITo,
          Loan_Id: this.Loan_Id,
          LoginUserId: this.currentUser.userId,
          chqId: this.ChequeId,
          Id: this.Id,
          StatusDate: this.StatusDate,
        })
        .subscribe((res: any) => {
          if (res[0].CODE == 0) {
            console.log("Data Saved");
            this.OnClose();
            this.onSearchEnachEasebuzz();
          } else {
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: res[0].MSG,
              ...this.configSuccess,
            });
          }
        });
    }
  }
  changeDate() {
    this.EMIFrom = 0;
    this.EMITo = 0;
    this.lmsService
      .LMS_GET_NACH_EMI_DETAI({
        StatusDate: this.StatusDate,
        Loan_Id: this.Loan_Id,
      })
      .subscribe((res: any) => {
        if (res.length > 0) {
          if (res[0].CODE == 0) {
            this.EMIFrom = res[0].EMI;
            this.EMITo = res[res.length - 1].EMI;
            this.LastEMI = res[res.length - 1].EMI;
          } else {
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: res[0].MSG,
              ...this.configSuccess,
            });
            this.EMIFrom = 0;
            this.EMITo = 0;
          }
        }
      });
  }
  onExport(exporter: any) {
    exporter.exportTable("xls", {
      fileName: `AU-ENACH-EASEBUZZ-EXPORT`,
      sheet: "AU-ENACH-EASEBUZZ-EXPORT",
    });
  }
  applyFilter(filterValue: string) {
    this.dataSourceEnachEasebuzz.filter = filterValue.trim().toLowerCase();
  }
}
